import { fetchContentGroupByName, fetchContentEntryById, fetchEntriesByFieldValue } from "../../api/contentGroups";
import { createSlice } from "@reduxjs/toolkit";

const contentGroupsSlice = createSlice({
    name: 'contentGroups',
    initialState: {
        entries: {}, // A dictionary to store multiple entries by id
        groups: {}, // A dictionary to store multiple groups by name
        filteredEntries: {}, // A dictionary to store entries filtered by field value

        status: {}, // A dictionary to manage loading state for each group
        error: {} // A dictionary to track errors for each group
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContentGroupByName.pending, (state, action) => {
                const groupName = action.meta.arg;
                state.status[groupName] = 'loading';
                state.error[groupName] = null;
            })
            .addCase(fetchContentGroupByName.fulfilled, (state, action) => {
                const groupName = action.meta.arg;
                state.status[groupName] = 'succeeded';
                state.groups[groupName] = action.payload?.items;
            })
            .addCase(fetchContentGroupByName.rejected, (state, action) => {
                const groupName = action.meta.arg;
                state.status[groupName] = 'failed';
                state.error[groupName] = action.payload;
            })
            .addCase(fetchContentEntryById.pending, (state, action) => {
                const contentId = action.meta.arg;
                state.status[contentId] = 'loading';
                state.error[contentId] = null;
            })
            .addCase(fetchContentEntryById.fulfilled, (state, action) => {
                const contentId = action.meta.arg;
                state.status[contentId] = 'succeeded';
                state.entries[contentId] = action.payload; // Save fetched entry by ID
            })
            .addCase(fetchContentEntryById.rejected, (state, action) => {
                const contentId = action.meta.arg;
                state.status[contentId] = 'failed';
                state.error[contentId] = action.payload;
            })
                    // New cases for fetchEntriesByFieldValue
            .addCase(fetchEntriesByFieldValue.pending, (state, action) => {
                const { contentType, fieldName, fieldValue } = action.meta.arg;
                const key = `${contentType}_${fieldName}_${fieldValue}`;
                state.status[key] = 'loading';
                state.error[key] = null;
            })
            .addCase(fetchEntriesByFieldValue.fulfilled, (state, action) => {
                const { contentType, fieldName, fieldValue } = action.meta.arg;
                const key = `${contentType}_${fieldName}_${fieldValue}`;
                state.status[key] = 'succeeded';
                state.filteredEntries[key] = action.payload;
            })
            .addCase(fetchEntriesByFieldValue.rejected, (state, action) => {
                const { contentType, fieldName, fieldValue } = action.meta.arg;
                const key = `${contentType}_${fieldName}_${fieldValue}`;
                state.status[key] = 'failed';
                state.error[key] = action.payload;
            })
              // fetchContentGroupById

    }
});

export default contentGroupsSlice.reducer;
